module.exports = __webpack_public_path__ + "img/hero.7ab1bee6.webp";